
import { Expense } from "../../classes"

const ExpenseModule = {
  namespaced: true,
  state: {
    expense: null
  },
  mutations: {
    setExpense(state, expense) {
      state.expense = expense
    },
    clearExpense: (state) => {
      state.expense = null
    },
  },
  actions: {
    getExpense: async ({ commit }, id) => {
      try{
        commit("clearExpense")
        const data = await Expense.getExpense(id)
        commit("setExpense", data)
        return data
      }catch(error){
        throw error
      }
    },
    createExpense: async ({ commit }, formData) => {
      try {
        const data = await Expense.createExpense(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateExpense: async ({ commit }, formData) => {
      try {
        const data = await Expense.updateExpense(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
    removeExpense: async ({ commit }, id) => {
      try {
        const data = await Expense.removeExpense(id);
        return data;
      } catch (error) {
        throw error;
      }
    },
  },
  getters: {

  },
};
export default ExpenseModule;
